import ShareAcceptModal from "@/components/Sharing/ShareAcceptModal"
import ShareCancelModal from "@/components/Sharing/ShareCancelModal"
import ShareCancelShareModal from "@/components/Sharing/ShareCancelShareModal"
import ShareDeclineModal from "@/components/Sharing/ShareDeclineModal"
import ShareDuplicateModal from "@/components/Sharing/ShareDuplicateModal"
import ShareEndModal from "@/components/Sharing/ShareEndModal"
import ShareResponseModal from "@/components/Sharing/ShareResponseModal"
import Header from "@/components/TableResults/Header"
import type { SHARED_DATA_TYPE_VALUE } from "@/domain/sharedData/constants"
import type { SharedDataJsonldReadCollectionSharedData } from "@/networking/api"
import { isNotNullNorUndefined } from "@/utils/ts-utils"
import { Table, Tbody, Thead, Tr, useDisclosure } from "@chakra-ui/react"
import { useState } from "react"
import { FormattedMessage } from "react-intl"
import { SharedTableRow } from "./SharedTableRow"

type Props = {
  items?: SharedDataJsonldReadCollectionSharedData[]
  type: SHARED_DATA_TYPE_VALUE
  fromOrTo: "from" | "to"
  refreshQueries?: () => void
}

const getItemById = (items: SharedDataJsonldReadCollectionSharedData[], id: string) => {
  for (const item of items) {
    if (item.id === id) return item
  }
  return {} as SharedDataJsonldReadCollectionSharedData
}

export const SharedTable: React.FC<Props> = ({ items, type, fromOrTo, refreshQueries }) => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { isOpen: isOpenAccept, onOpen: onOpenAccept, onClose: onCloseAccept } = useDisclosure()
  const { isOpen: isOpenDecline, onOpen: onOpenDecline, onClose: onCloseDecline } = useDisclosure()
  const { isOpen: isOpenCancel, onOpen: onOpenCancel, onClose: onCloseCancel } = useDisclosure()
  const {
    isOpen: isOpenCancelShare,
    onOpen: onOpenCancelShare,
    onClose: onCloseCancelShare,
  } = useDisclosure()
  const { isOpen: isOpenEnd, onOpen: onOpenEnd, onClose: onCloseEnd } = useDisclosure()
  const {
    isOpen: isOpenDuplicate,
    onOpen: onOpenDuplicate,
    onClose: onCloseDuplicate,
  } = useDisclosure()

  const [currentItem, setCurrentItem] = useState<SharedDataJsonldReadCollectionSharedData>(
    {} as SharedDataJsonldReadCollectionSharedData
  )

  const [isKo, setIsKo] = useState(false)
  const onOpenEndOk = () => {
    setIsKo(false)
    onOpenEnd()
  }
  const onOpenEndKo = () => {
    setIsKo(true)
    onOpenEnd()
  }

  const [isRevoke, setIsRevoke] = useState(false)
  const onOpenRevoke = () => {
    setIsRevoke(true)
    onOpenDecline()
  }

  const openRow = (id: string) => {
    setCurrentItem(getItemById(items ?? [], id))
    if (isNotNullNorUndefined(currentItem)) onOpen()
  }

  return (
    <>
      <Table variant="simple" color="textMuted">
        <Thead>
          <Tr>
            <Header>
              <FormattedMessage id={`sharing.${type}.type`} />
            </Header>
            <Header>
              <FormattedMessage id="sharing.sharedItem.name" />
            </Header>
            <Header>
              <FormattedMessage id="sharing.sharedItem.cluster" />
            </Header>
            <Header>
              <FormattedMessage id="sharing.sharedItem.createdAt" />
            </Header>
            <Header>
              <FormattedMessage id="sharing.sharedItem.responseAt" />
            </Header>
            <Header>
              <FormattedMessage id="sharing.sharedItem.status" />
            </Header>
          </Tr>
        </Thead>
        <Tbody>
          {items?.map(item => (
            <SharedTableRow item={item} key={item.id} fromOrTo={fromOrTo} onOpen={openRow} />
          ))}
        </Tbody>
      </Table>

      <ShareResponseModal
        isOpen={isOpen}
        onClose={onClose}
        onOpenAccept={onOpenAccept}
        onOpenDecline={onOpenDecline}
        onOpenRevoke={onOpenRevoke}
        onOpenCancel={onOpenCancel}
        onOpenCancelShare={onOpenCancelShare}
        onOpenEndOk={onOpenEndOk}
        onOpenEndKo={onOpenEndKo}
        onDuplicate={onOpenDuplicate}
        refreshQueries={refreshQueries}
        sharedEntity={currentItem}
        fromOrTo={fromOrTo}
      />
      <ShareAcceptModal
        isOpen={isOpenAccept}
        onClose={() => {
          onCloseAccept()
          refreshQueries?.()
        }}
        sharedEntity={currentItem}
      />
      <ShareDeclineModal
        isOpen={isOpenDecline}
        onClose={() => {
          onCloseDecline()
          refreshQueries?.()
        }}
        sharedEntity={currentItem}
        isRevoke={isRevoke}
      />
      <ShareCancelModal
        isOpen={isOpenCancel}
        onClose={() => {
          onCloseCancel()
          refreshQueries?.()
        }}
        sharedEntity={currentItem}
      />
      <ShareCancelShareModal
        isOpen={isOpenCancelShare}
        onClose={() => {
          onCloseCancelShare()
          refreshQueries?.()
        }}
        sharedEntity={currentItem}
      />
      <ShareEndModal
        isOpen={isOpenEnd}
        onClose={() => {
          onCloseEnd()
          refreshQueries?.()
        }}
        sharedEntity={currentItem}
        isKo={isKo}
      />
      <ShareDuplicateModal
        isOpen={isOpenDuplicate}
        onClose={refresh => {
          onCloseDuplicate()
          if (refresh) refreshQueries?.()
        }}
        sharedEntity={currentItem}
      />
    </>
  )
}
